import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { updateSegment } from '../../../redux/currentSearch/actions';
import {
    getDestinationErrorSelector,
    getActiveProduct,
    isMultipleSegments,
    getDestinationHotelErrorSelector,
    getSegmentConfig,
} from '../../../redux/currentSearch/selectors';
import { useSegmentContext } from './SegmentManager/Context';
import { EntryPoint, LocationHotelsSuppliers, SegmentConfigType, SegmentPropDefault } from '../../../models';

const getArrivalValue = (activeProduct, segment) => {
    if (
        activeProduct === EntryPoint.HOTELS
        && segment.destination?.geoNodeId
    ) {
        segment.destination = undefined;
        return segment.destination;
    }
    if (activeProduct !== EntryPoint.HOTELS || segment.destination?.geoNodeIdSupplier === LocationHotelsSuppliers.HSA) {
        return segment.destination;
    }
    updateSegment({ destination: undefined }, segment.id);
};

const SegmentArrival = ({
    children,
    updateSegment,
    destinationError,
    destinationHotelError,
    activeProduct,
    isMultipleSegments,
    segmentConfig,
}) => {
    const { segment } = useSegmentContext();
    const value = getArrivalValue(activeProduct, segment);
    const error = activeProduct === EntryPoint.HOTELS ? destinationHotelError : destinationError;
    const isDisabled = !segmentConfig.destination.enabled;

    const setValue = (destination) => {
        if (value !== destination) {
            updateSegment({ destination }, segment.id);
        }
    };

    return children({ error, setValue, value, activeProduct, isMultipleSegments, isDisabled });
};

SegmentArrival.propTypes = {
    children: PropTypes.func.isRequired,
    updateSegment: PropTypes.func.isRequired,
    segmentConfig: SegmentConfigType.isRequired,
};

SegmentArrival.defaultProps = {
    children: null,
    updateSegment: () => {},
    segmentConfig: SegmentPropDefault,
};

const mapStateToPropsSelector = createStructuredSelector({
    destinationError: getDestinationErrorSelector,
    destinationHotelError: getDestinationHotelErrorSelector,
    activeProduct: getActiveProduct,
    isMultipleSegments: isMultipleSegments,
    segmentConfig: getSegmentConfig,
});

export const ConnectedSegmentArrival = connect(mapStateToPropsSelector, {
    updateSegment,
})(SegmentArrival);
